import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import './plugins/toasted'
import App from './App.vue'
import router from './router'
import store from './store'

import './styles/main.styl'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
